<p
    *ngIf="body?.description as description"
    #text
    [ngxTruncateText]="description"
    [nbTooltip]="description"
    [nbTooltipTrigger]="text.innerText !== description ? NbTrigger.HOVER : NbTrigger.NOOP"
>
    {{ description }}
</p>
